import { useEntryGroupsCache } from "@/shared/cache";
import type { Entry } from "./normalize";

/**
 * Thin adapter around the entry-group cache so the view keeps its existing
 * `{ data, isLoading }` contract.
 */
export function useAllEntries(
	timekeeperId?: string | null,
	enabled = true,
): {
	data: Entry[];
	isLoading: boolean;
} {
	const { entries, isLoading } = useEntryGroupsCache(undefined, enabled, {
		timekeeperId,
	});
	return { data: entries, isLoading: !enabled || isLoading };
}
